:host {
	background-color: rgba(var(--smoothly-default-color), 1);
	opacity: var(--opacity);
	pointer-events: var(--pointer-events);
	transition: opacity 400ms;
	z-index: 3;
	border-radius: 50%;
	box-shadow: var(--smoothly-shadow);
	height: 3rem;
	width: 3rem;
	position: fixed;
	bottom: var(--bottom);
	right: var(--right);
	outline: none;
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
}
